<div class="col-sm-12">
    <app-card [hidHeader]="true" cardClass="card-datatable">
      <br />
      <div class="table-responsive">
        <table  datatable [dtOptions]="dtOptions"
          class="table table-sm table-striped table-bordered nowrap table-hover">
          <thead class="thead-light">
            <tr>
              <th>Libellé</th>
              <th>État</th>
              <th>Crée le</th>
              <th>Montant</th>
              <th>Payé</th>
              <th>Impayé </th>
              <th>Trop perçu </th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of autres">
              <td>
                <p class="m-0 d-inline-block align-middle font-16">{{ item?.libelle }}</p>
              </td>
              <td>
                <span class="badge" [ngClass]="{
                'badge-danger' : item?.etat === 'IMPAYÉ',
                'badge-primary' : item?.etat === 'ATTENTE',
                'badge-warning' : item?.etat === 'EN COURS',
                'badge-success' : item?.etat === 'SOLDE'
                }">{{PAYMENT(item.etat)}}</span>
              </td>
              <td>{{item?.createdAt|date: "d MMMM y 'à' h:mm:ss" : '' : 'fr-FR'}}</td>
              <td class="align-middle">
                <span class="text-primary font-weight-blod">{{item?.montant|number}} {{global.device}}</span>
              </td>
              <td class="align-middle">
                <span class="text-success font-weight-blod">{{item?.paye|number}} {{global.device}}</span>
              </td>
              <td class="align-middle">
                <span class="text-danger font-weight-blod">{{item.impaye|number}} {{global.device}}</span>
              </td>
              <td class="align-middle">
                <span class="text-danger font-weight-blod">{{item.solde|number}} {{global.device}}</span>
              </td>
              <td class="table-action">
                <div class="overlay-edit">
                  <button (click)="showAutre(item)" type="button" class="btn btn-icon btn-secondary" ngbTooltip="Détails">
                    <i class="fas fa-eye"></i>
                  </button>
                  <button *ngIf="item?.etat === 'ATTENTE'" (click)="editAutre(item)" type="button"
                    class="btn btn-icon  btn-primary  ml-1" ngbTooltip="Modifier">
                    <i class="feather icon-edit-2"></i>
                  </button>
                  <button (click)="printerInvoice(item)" type="button"
                    class="btn btn-icon btn-info ml-1" ngbTooltip="Imprimer le reçu">
                    <i class="fas fa-print"></i>
                  </button>
                  <button *ngIf="item?.contract?.etat !== 'RESILIE'" type="button" (click)="delete(item)"
                    class="btn btn-icon btn-danger ml-1" ngbTooltip="Supprimer">
                    <i class="feather icon-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
  